// extracted by mini-css-extract-plugin
export default {"buttonContainer":"button_buttonContainer__A6GTi","label":"button_label__Hx2ZP","primary":"button_primary__ORBqv"};